import React from "react";
import { MailIcon, MessageCircleIcon } from "lucide-react";
import { ContactForm } from "./ContactForm";
import { contactInfo, whatsappNumbers } from "../data/content";
export function Contact() {
  return <section id="contacto" className="scroll-mt-20 bg-paper text-ink" data-id="element-31" data-mp="317lb1wccnekf">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8 lg:py-32" data-id="element-32" data-mp="2w7qizpgu8ixs">
        <div data-id="element-33" data-mp="3sxzib9puxsn4">
          <p className="text-sm font-medium text-gold-deep" data-id="element-34" data-mp="3swoitm3g371t">Contacto</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-35" data-mp="3ovmeiquo84sz">Agenda una consulta con Fortis</h2>

          <ul className="mt-12 space-y-6" data-id="element-36" data-mp="3k4mlhwooa6vr">
            <li className="flex items-start gap-4" data-id="element-37" data-mp="3k3bd1jka8ayb">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-38" data-mp="3f74fof5yc7rz">
                <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-39" data-mp="gh4bx4ni1hgr" />
              </span>
              <div data-id="element-40" data-mp="boufr6vsjl61">
                <span className="block text-sm text-ink/60" data-id="element-41" data-mp="bob9wojf0n8d">WhatsApp</span>
                <ul className="mt-1 space-y-1" data-id="element-42" data-mp="3jww3ghm1q0bz">
                  {whatsappNumbers.map(number => <li key={number.url} data-id="element-43" data-mp="3otcsrf4zekqn">
                      <a href={number.url} target="_blank" rel="noopener noreferrer" className="text-lg font-medium transition-colors duration-150 ease-out hover:text-gold-deep" data-id="element-44" data-mp="3owik71131ypj">
                        {number.display}
                      </a>
                    </li>)}
                </ul>
              </div>
            </li>
            <li data-id="element-45" data-mp="2s5zrrkbq21qa">
              <a href={`mailto:${contactInfo.email}`} className="group flex items-center gap-4" data-id="element-46" data-mp="2s6hwl5cg9o9t">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-47" data-mp="2w834eca4ncd5">
                  <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-48" data-mp="uenc7aye5pg2" />
                </span>
                <span className="min-w-0" data-id="element-49" data-mp="ucayj9zo218t">
                  <span className="block text-sm text-ink/60" data-id="element-50" data-mp="23bu4wf3gxmea">Correo</span>
                  <span className="block break-all text-lg font-medium transition-colors duration-150 ease-out group-hover:text-gold-deep" data-id="element-51" data-mp="1ycqzuunhng6b">
                    {contactInfo.email}
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>

        <ContactForm data-id="element-52" data-mp="2m225apfs9yqs" />
      </div>
    </section>;
}